//import api from '../api';
import { newAPIPost } from '../api/index.js';


export default {
  state: {
    doheader: [],
    searchRequest: {},
  },
  mutations: {
    updateDoheader(state, doheader) {
      // console.log('tiger');
      state.doheader = doheader;
    },
    updateSearchDoheaderRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async doheader({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
     
    //   if (requestToSend.cutLFD.startDate)
    // {
    //     const date = moment(requestToSend.cutLFD.startDate)
    //                 .endOf('d')
    //                 .toDate();
    //     console.log(date)
    //     console.log(date.getMonth())
    //     console.log(date.getDate())
    //     var month = (date.getMonth() + 1).toString()
    //     if (month.length === 1)
    //     {
    //         month = '0' + month
    //     }

    //     var day = date.getDate().toString()
    //     if (day.length === 1)
    //     {
    //         day = '0' + day
    //     }
    //     requestToSend.cutLFD.startDate = date.getFullYear() + '-' + month + '-' + day
    // }

    // if (requestToSend.cutLFD.endDate)
    // {
    //     const date = moment(requestToSend.cutLFD.endDate)
    //                 .endOf('d')
    //                 .toDate();

    //                 var month = (date.getMonth() + 1).toString()
    //                 if (month.length == 1)
    //                 {
    //                     month = '0' + month
    //                 }
            
    //                 var day = date.getDate().toString()
    //                 if (day.length == 1)
    //                 {
    //                     day = '0' + day
    //                 }
    //     requestToSend.cutLFD.endDate = date.getFullYear() + '-' + month + '-' + day
    // }
    // else
    // {
    //   if (requestToSend.cutLFD.startDate != null)
    //   {
    //     const date = moment(requestToSend.cutLFD.startDate)
    //                 .endOf('d')
    //                 .toDate();
    //     console.log(date)
    //     console.log(date.getMonth())
    //     console.log(date.getDate())
    //     var month = (date.getMonth() + 1).toString()
    //     if (month.length === 1)
    //     {
    //         month = '0' + month
    //     }

    //     var day = date.getDate().toString()
    //     if (day.length === 1)
    //     {
    //         day = '0' + day
    //     }

    //     requestToSend.cutLFD.endDate = date.getFullYear() + '-' + month + '-' + day
    //   }
        
    // }


    // if (requestToSend.cutLFD.startDate)
    // {
    //   requestToSend.cutLFD.startDate = dateFormat.getLocalDate(requestToSend.cutLFD.startDate);
    // }

    // if (requestToSend.cutLFD.endDate)
    // {
    //   requestToSend.cutLFD.endDate = dateFormat.getLocalDateEnd(requestToSend.cutLFD.endDate);
    // }
    // else
    // {
    //   requestToSend.cutLFD.endDate = dateFormat.getLocalDateEnd(requestToSend.cutLFD.startDate);
    // }


    // requestToSend.cutLFD.startDate = "2000-01-01"
    // requestToSend.cutLFD.endDate = "2099-12-31"

      // console.log(requestToSend);
      //const result = await api.post('/api/w/do/doheader', requestToSend);
      const result = await newAPIPost('/api/w/do/doheader', requestToSend);
      commit('updateSearchDoheaderRequest', fallbackRequest);
      return commit('updateDoheader', result);
    },
    saveDoheader({ dispatch }, request) {


      const requestToSend = JSON.parse(JSON.stringify(request));

      // if (requestToSend.cutLFD)
      // {
      //     const date = moment(requestToSend.cutLFD)
      //                 .endOf('d')
      //                 .toDate();
      //     // console.log(date)
      //     // console.log(date.getMonth())
      //     // console.log(date.getDate())
      //     var month = (date.getMonth() + 1).toString()
      //     if (month.length === 1)
      //     {
      //         month = '0' + month
      //     }
  
      //     var day = date.getDate().toString()
      //     if (day.length === 1)
      //     {
      //         day = '0' + day
      //     }
  
      //     requestToSend.cutLFD = date.getFullYear() + '-' + month + '-' + day
      // }

      //return api.post('/api/w/do/doheader/action', requestToSend)
      return newAPIPost('/api/w/do/doheader/action', requestToSend)
    },
  },
  getters: {
    getDoheader: state => state.doheader,
  },
};
